export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["منشور مجهول، جارٍ البحث عنه…"])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أعجِب بمنشورك"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يُتابعك"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحميل الإشعارات الأقدم"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الإخطارات"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مقروء!"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شارَك منشورك"])}
  }
}